/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCharactersCharacterIdMailMailIdNotFound
 */
export interface GetCharactersCharacterIdMailMailIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCharactersCharacterIdMailMailIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdMailMailIdNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdMailMailIdNotFound(value: object): value is GetCharactersCharacterIdMailMailIdNotFound {
    return true;
}

export function GetCharactersCharacterIdMailMailIdNotFoundFromJSON(json: any): GetCharactersCharacterIdMailMailIdNotFound {
    return GetCharactersCharacterIdMailMailIdNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdMailMailIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdMailMailIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdMailMailIdNotFoundToJSON(json: any): GetCharactersCharacterIdMailMailIdNotFound {
    return GetCharactersCharacterIdMailMailIdNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdMailMailIdNotFoundToJSONTyped(value?: GetCharactersCharacterIdMailMailIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

